import React from "react";
import "./InnovationParticipation.css";

const focusAreas = [
  {
    title: "AI-enabled platforms",
    desc: "Ecosystem-aligned participation in intelligent digital platforms built around applied AI."
  },
  {
    title: "Synthetic systems",
    desc: "Strategic alignment in synthetic data, simulation systems, and persona-driven environments."
  },
  {
    title: "Decision-support ecosystems",
    desc: "Innovation themes centered on structured intelligence, analytics, and decision tools."
  }
];

const InnovationParticipation = () => {
  return (
    <section className="innovation-section">
      <div className="container innovation-wrapper">

        {/* LEFT CONTENT */}
        <div className="innovation-left">
          <h2>Innovation Participation</h2>

          <p>
            In selected cases, Karma & Delta may participate on its own account
            in innovation-led ventures, digital platforms, or emerging technology
            initiatives that align with our long-term view of AI, research, and
            next-generation business models.
          </p>

          <p>
            Our emphasis is on strategic alignment, product vision, and ecosystem
            value creation, particularly in areas such as AI-enabled platforms,
            synthetic data, synthetic persona systems, decision-support tools,
            and related innovation ecosystems.
          </p>

          <div className="innovation-disclaimer">
            Karma & Delta does not hold itself out to the public as a fund
            manager, financial intermediary, or provider of regulated investment
            services. Any proprietary participation is selective, internal, and
            aligned with applicable licensed activities.
          </div>
        </div>

        {/* RIGHT VISUAL BLOCKS */}
        <div className="innovation-right">
          {focusAreas.map((area, index) => (
            <div key={index} className="innovation-card">
              <h3>{area.title}</h3>
              <p>{area.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default InnovationParticipation;